















































import Vue from 'vue'

const columns = [
    {
        title: 'ID',
        dataIndex: 'tenantId',
        key: 'tenantId',
        ellipsis: false,
        width: 80
    },
    {
        title: '编号',
        dataIndex: 'tenantCode',
        key: 'tenantCode',
        ellipsis: true,
        width: 100,
        scopedSlots: { customRender: 'tenantCode' }
    },
    {
        title: '名称',
        dataIndex: 'tenantName',
        key: 'tenantName',
        width: 184,
        ellipsis: true,
        scopedSlots: { customRender: 'tenantName' }
    },
    {
        title: '到期时间',
        dataIndex: 'expireTime',
        key: 'expireTime',
        width: 166,
        ellipsis: true,
        scopedSlots: { customRender: 'expireTime' }
    }
]

import {
    MasterlinkTenantServiceProxy,
} from '@/service-proxies/app-v2/system.service-proxies'

const TenantService = new MasterlinkTenantServiceProxy()

export default Vue.extend({
    name: 'TenantSelect',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: [String, Number, Array],
            default: () => undefined
        },
        placeholder: {
            type: String
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedValue: undefined,
            selectOptions: [],
            modalVisible: false,
            totalContent: 0, // 表单列表数
            dataSource: [],
            tenantListLoading: false,
            selectedRowKeys: [],
            selectedRows: [],
            selectedTenant: [],
            filter: {
                // 查询条件
                size: 20,
                current: 1,
                tenantInfo: ''
            },
            columns,
        }
    },
    computed: {
        mode() {
            if (this.multiple) {
                return 'tags'
            }
            return 'default'
        },
        rowSelectionType() {
            if (this.multiple) {
                return 'checkbox'
            }
            return 'radio'
        },
        selectedLength() {
            if (this.selectedRowKeys) {
                return this.selectedRowKeys.length;
            }
            return 0;
        },
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    this.addSelectedTenant(selectedRows);
                    this.selectedRows = selectedRows;
                    this.selectedRowKeys = selectedRowKeys;
                },
                type: this.rowSelectionType,
                selectedRowKeys: this.selectedRowKeys
            };
        },
    },
    mounted() {
        // 需要对租户进行初始化选择
        this.selectedValue = this.value;
        this.initTenant()
            .then(res => {
                this.resetSelectOptions();
            });
    },
    methods: {
        updateValue(value) {
            this.selectedValue = value;
            this.$emit('change', value)
        },
        openModal() {
            this.filter = {
                // 查询条件
                size: 20,
                current: 1,
                tenantInfo: ''
            };
            this.modalVisible = true;

            if (this.selectedValue) {
                if (this.multiple) {
                    this.selectedRowKeys = this.selectedValue;
                } else {
                    this.selectedRowKeys = [this.selectedValue];
                }
            } else {
                this.selectedRowKeys = [];
            }
            this.getTenantList();
        },
        addSelectedTenant(selectedRows: any[]) {
            if (this.selectedTenant === undefined) {
                this.selectedTenant = [];
            }

            for (const item of selectedRows) {
                const exist = this.selectedTenant.find(c => c.tenantId === item.tenantId)
                if (exist) {
                    continue;
                }
                this.selectedTenant.push(item);
            }

        },
        handleOk() {
            console.log('handleOk selectedRows:', this.selectedTenant);
            this.modalVisible = false;
            this.resetSelectOptions();
            if (this.multiple) {
                this.updateValue(this.selectedRowKeys)
            } else {
                if (this.selectedRowKeys.length > 0) {
                    this.updateValue(this.selectedRowKeys[0])
                }

            }

        },
        onSelectValueChange(value) {
            this.updateValue(value);
        },
        handleCancel() {
            this.modalVisible = false;
        },
        handlesearch(value: any) {
            this.filter.tenantInfo = value
            this.pageIndexchange(1)
        },
        onShowSizeChange(current, pageSize) {
            this.filter.size = pageSize;
            this.pageIndexchange(current);
        },
        pageIndexchange(current: any) {
            this.filter.current = current
            this.getTenantList()
        },
        resetSelectOptions() {
            this.selectOptions = [];

            if (!this.selectedTenant) {
                return [];
            }
            const result = this.selectedTenant.map(c => ({
                value: c.tenantId,
                label: c.tenantCode,
            }));

            this.selectOptions = result;
        },
        async initTenant() {
            if (this.value === undefined) {
                return;
            }

            let codeList: string[] = [];
            if (this.multiple) {
                codeList.push(...this.value);
            } else {
                codeList.push(this.value);
            }
            for (const item of codeList) {
                const tenant = await TenantService.queryRole(item);
                this.selectedTenant.push(tenant.data);

            }
        },
        getTenantList() {
            this.tenantListLoading = true;
            TenantService.getTenants(
                undefined,
                this.filter.current,
                this.filter.size,
                undefined,
                this.filter.tenantInfo
            ).then((res: any) => {
                if (res.data.records) {
                    this.totalContent = res.data.total
                    this.dataSource = res.data.records
                }
            }).finally(() => {
                this.tenantListLoading = false;
            });
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.selectedValue = newVal;
            }
        },
    }
})
